/* remove-button.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./remove-button.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@atlaskit/css';
import CloseIcon from '@atlaskit/icon/core/migration/cross--editor-close';
import { fg } from '@atlaskit/platform-feature-flags';
import { Pressable } from '@atlaskit/primitives/compiled';
var removeButtonStyles = {
  root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr31dpa _1di6fcek"
};
var removeButtonStylesOldIcon = {
  root: "_rjxpze3t"
};
var removeButtonStylesNewIcon = {
  root: "_rjxpv77o"
};
var RemoveButton = function RemoveButton(_ref) {
  var ariaLabel = _ref['aria-label'],
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onKeyPress = _ref.onKeyPress,
    onMouseOver = _ref.onMouseOver,
    onMouseOut = _ref.onMouseOut,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Pressable, {
    xcss: cx(removeButtonStyles.root, removeButtonStylesOldIcon.root, fg('platform-visual-refresh-icons') && removeButtonStylesNewIcon.root),
    "aria-label": ariaLabel,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyPress: onKeyPress,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    testId: testId
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: "currentColor",
    label: "",
    LEGACY_size: "small",
    size: "small"
  }));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default RemoveButton;